import { render } from "./CreateRequest3.vue?vue&type=template&id=2a3f4784"
import script from "./CreateRequest3.vue?vue&type=script&lang=js"
export * from "./CreateRequest3.vue?vue&type=script&lang=js"

import "./CreateRequest3.vue?vue&type=style&index=0&id=2a3f4784&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__